<div
  appDataCy="creel-position"
  class="draggable-item"
  (click)="onCreelPositionClick(creelPosition, creelPosition.isSelected, $event)"
  [class.can-show-warning]="canShowWarning(creelPosition)"
  #creelPositionElement
>
  <div class="warning-indicator" *ngIf="canShowWarning(creelPosition)"></div>
  <div class="selected-indicator" *ngIf="creelPosition.isSelected"></div>

  <div fxFlex fxLayoutGap="4px">
    <div fxLayoutAlign="start center" fxFlex>
      <mat-icon *ngIf="canEditMaterialSet" class="drag-handle" svgIcon="drag-handle"></mat-icon>
      <mat-icon svgIcon="creel-position"></mat-icon>

      <label appDataCy="creel-position-number" class="position">
        {{ creelPositionIndex + 1 }}
      </label>
    </div>

    <mat-icon *ngIf="canShowWarning(creelPosition)" svgIcon="error"></mat-icon>

    <div fxLayoutAlign="end center" fxLayoutGap="8px">
      <app-preview-for-creel-position [maxMaterialTypesToShow]="3" [materialSet]="materialSet" [creelPosition]="creelPosition"></app-preview-for-creel-position>
    </div>
  </div>
</div>
